export default () => ({
	init() {
		this.initQuickAdd()
		this.initHoverVideo()
	},

	initQuickAdd() {
		const button = this.$el.querySelector('[data-add-to-cart]')
		if (!button) return

		button.addEventListener('click', async (e) => {
			e.preventDefault()
			e.stopPropagation()

			const variantId = button.dataset.productId
			if (!variantId) return

			button.disabled = true
			button.textContent = 'Adding...'

			const payload = [
				{
					id: Number(variantId),
					quantity: 1,
				},
			]

			const cart = this.$store.cart

			await cart.addLines(payload, () => {
				button.textContent = 'Added!'
				setTimeout(() => {
					button.textContent = 'Quick Add'
					button.disabled = false
				}, 2000)
			})
		})
	},

	initHoverVideo() {
		const video = this.$el.querySelector('[data-hover-video]')
		if (!video) return

		this.$el.addEventListener('mouseenter', () => {
			video.play().catch(() => {})
		})

		this.$el.addEventListener('mouseleave', () => {
			video.pause()
			video.currentTime = 0
		})
	},
})
